export enum SelectionActionType {
  SET_SELECTED_CLIENTS = `SET_SELECTED_CLIENTS`,
  SET_SELECTED_VEHICLES = `SET_SELECTED_VEHICLES`,
  SET_SELECTED_SUPERVISORS = `SET_SELECTED_SUPERVISORS`,
}

export interface SetSelectedClientsAction {
  type: SelectionActionType.SET_SELECTED_CLIENTS;
  payload: {
    selectedClients: Array<string>;
  };
}

export interface SetSelectedVehiclesAction {
  type: SelectionActionType.SET_SELECTED_VEHICLES;
  payload: {
    selectedVehicles: Array<string>;
  };
}

export interface SetSelectedSupervisorsAction {
  type: SelectionActionType.SET_SELECTED_SUPERVISORS;
  payload: {
    selectedSupervisors: Array<string>;
  };
}

export type SelectionActions = SetSelectedClientsAction | SetSelectedVehiclesAction | SetSelectedSupervisorsAction;
